import React from 'react';

const Container = ({ children, className = '' }) => (
  <div className={`max-w-4xl mx-auto p-4 ${className}`}>
    {children}
  </div>
);

export default Container;